// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__x7sUZ","alertIcon":"ConfirmModal_alertIcon__3yGEE"};